import type { ModulePermissionShape } from "@/types/permissions";

export const projectPermissionKeys = [
  "projects_read_basic",
  "projects_read_full",
  "projects_approve",
  "projects_reject",
  "projects_close",
  "projects_request_approval",
  "projects_delete",
  "projects_reopen",
  "projects_restore",
  "project_managers_read",
] as const;

export type ProjectPermissions = ModulePermissionShape<
  typeof projectPermissionKeys
>;
